// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-header {\n  display: flex;\n  align-items: center;\n  font-size: 18px;\n  height: 32px;\n  line-height: 32px;\n  margin-bottom: 24px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
